var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationOrchestrator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3H15C15.5523 3 16 3.44772 16 4V8C16 8.55228 15.5523 9 15 9H9C8.44772 9 8 8.55228 8 8V4C8 3.44772 8.44772 3 9 3Z",
    fill: "#B9B4CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15H11C11.5523 15 12 15.4477 12 16V20C12 20.5523 11.5523 21 11 21H5C4.44772 21 4 20.5523 4 20V16C4 15.4477 4.44772 15 5 15Z",
    fill: "#B9B4CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15H19C19.5523 15 20 15.4477 20 16V20C20 20.5523 19.5523 21 19 21H13C12.4477 21 12 20.5523 12 20V16C12 15.4477 12.4477 15 13 15Z",
    fill: "#B9B4CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 9H12.75V13.25H11.25V9Z",
    fill: "#B9B4CA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.25H16.5V14.75H7.5V13.25Z",
    fill: "#B9B4CA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 14.75H8.625V16H7.125V14.75Z",
    fill: "#B9B4CA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 14.75H16.875V16H15.375V14.75Z",
    fill: "#B9B4CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOrchestrator);
export default __webpack_public_path__ + "static/media/notificationOrchestrator.ba8d7440ada145b2c9a39e3fc7b5eb39.svg";
export { ForwardRef as ReactComponent };